import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tabs,
  Tab,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import { useState, useEffect } from 'react'
import { QuantityModalProps } from './QuantityModal.types'

const QuantityModal = ({
  open,
  onClose,
  onConfirm,
  product,
  existingMeasurement,
}: QuantityModalProps) => {
  const [tab, setTab] = useState(1)
  const [numerator, setNumerator] = useState(
    existingMeasurement?.numerator || 1
  )
  const [denominator, setDenominator] = useState(
    existingMeasurement?.denominator || 4
  )

  // Reset values when modal opens with new product or existing measurement
  useEffect(() => {
    if (open) {
      setNumerator(existingMeasurement?.numerator || 1)
      setDenominator(existingMeasurement?.denominator || 4)
    }
  }, [open, existingMeasurement])

  const handleConfirm = () => {
    if (tab === 0) {
      // ML tab
      // onConfirm({
      //   type: 'ml',
      //   value: parseFloat(mlValue),
      //   unit: 'ml',
      // })
    } else {
      // Fraction tab
      onConfirm({
        type: 'fraction',
        value: numerator / denominator,
        unit: `${numerator}/${denominator}`,
        numerator: numerator,
        denominator: denominator,
      })
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {existingMeasurement ? 'Edit' : 'Specify'} Amount for {product?.name}
      </DialogTitle>
      <DialogContent>
        <Tabs value={tab} onChange={(_, newValue) => setTab(newValue)}>
          {/* <Tab label="Milliliters (mL)" /> */}
          <Tab label="Fraction" />
        </Tabs>

        {/* {tab === 0 ? (
          <div style={{ marginTop: 20 }}>
            <TextField
              label="Amount (mL)"
              type="number"
              value={mlValue}
              onChange={(e) => setMlValue(e.target.value)}
              fullWidth
              InputProps={{ inputProps: { min: 0, step: 0.1 } }}
            />
          </div>
        ) : (
          <></>
        )} */}

        <div
          style={{
            marginTop: 20,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <FormControl style={{ width: 100 }}>
            <InputLabel>Amount</InputLabel>
            <Select
              value={numerator}
              onChange={(e) => setNumerator(Number(e.target.value))}
              label="Amount"
            >
              {Array.from({ length: denominator }, (_, i) => i + 1).map(
                (num) => (
                  <MenuItem key={num} value={num}>
                    {num}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>
          <Typography variant="h6">/</Typography>
          <FormControl style={{ width: 100 }}>
            <InputLabel>Total</InputLabel>
            <Select
              value={denominator}
              onChange={(e) => {
                const newDenom = Number(e.target.value)
                setDenominator(newDenom)
                if (numerator > newDenom) {
                  setNumerator(newDenom)
                }
              }}
              label="Total"
            >
              {[2, 4, 5, 6, 10, 12, 35].map((num) => (
                <MenuItem key={num} value={num}>
                  {num}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          // disabled={tab === 0 ? !mlValue : false}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default QuantityModal
